import React, { useEffect, useRef, useState } from "react"
import profileIcon from "../../asset/profile_icon.png"
import LogoutButton from "./LogoutButton"
import { container } from "../../infrastructure/container"
import { SessionService } from "../../infrastructure/services/session"
import { SupportRole } from "../../infrastructure/models/common/supportrole"
import MyAccount from "./MyAccount"
import { useNavigate } from "react-router-dom"

const ProfileMenu: React.FC = () => {
  const sessionService = container.resolve<SessionService>("sessionService")
  const user = sessionService.user
  const navigate = useNavigate()

  const [showProfileMenu, setShowProfileMenu] = useState<boolean>(false)
  const profileMenuRef = useRef<HTMLDivElement>(null)
  const [phoneNumber, setPhoneNumber] = useState<string>("")

  useEffect(() => {
    /**
     * Fetches the stored phone number from localStorage when the component mounts.
     */
    if (user) {
      setPhoneNumber(user.phone || "No Phone Number")
    }
  }, [user])

  useEffect(() => {
    /**
     * Handles clicking outside the profile menu to close it.
     * @param {MouseEvent} event - The click event.
     */
    const handleClickOutside = (event: MouseEvent) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target as Node)
      ) {
        setShowProfileMenu(false)
      }
    }

    if (showProfileMenu) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showProfileMenu])

  const toggleProfileMenu = (event: React.MouseEvent) => {
    event.stopPropagation()
    setShowProfileMenu((prev) => !prev)
  }

  /**
   * Gets the role name from the FranchiseRole enum using reverse mapping.
   * @param role - The role value (e.g., 0, 1, 2).
   * @returns The role name as a string (e.g., "OWNER", "ADMIN").
   */
  const getRoleName = (role: SupportRole): string => {
    return SupportRole[role] || "Unknown"
  }

  const handleMyAccountClick = () => {
    navigate("/myaccount");
  }

  return (
    <div className="absolute top-6 right-6 z-50">
      <img
        src={user?.profileImage || profileIcon}
        alt="Profile"
        className="w-12 h-12 rounded-full cursor-pointer"
        onClick={toggleProfileMenu}
      />

      {showProfileMenu && (
        <div
          ref={profileMenuRef}
          className="absolute top-16 right-0 bg-white shadow-lg rounded-lg p-4 w-48 z-50"
        >
          <div className="text-sm text-gray-700">
            <p className="font-semibold">
              {user?.firstname || ""} {user?.lastname || "Unknown"}
            </p>
            <p className="break-words">{user?.email || "No Email"}</p>
            <p>{phoneNumber}</p>
            <p className="text-xs text-gray-600">
              {`Role: ${getRoleName(user?.role)}`}
            </p>

            <button onClick={handleMyAccountClick} className="text-blue-600 hover:text-blue-800 font-medium" >
              My Account
            </button>

          </div>
          <LogoutButton className="mt-3 text-red-500 hover:text-red-700 text-xs font-medium" />
        </div>
      )}
    </div>
  )
}

export default ProfileMenu